import BaseResource from './BaseResource';

export default class QuotePurchaseSettingsResource extends BaseResource {
  constructor(url) {
    super({ url });
  }

  get() {
    return super
      .get()
      .then((response) => response)
      .catch((error) => error.response);
  }

  update(data) {
    return super
      .patch(data)
      .then((response) => response)
      .catch((error) => error.response);
  }
}
